import Vue from "vue";
import {
  ToastPlugin,
  ModalPlugin,
  VBTooltipPlugin,
  VBToggle,
} from "bootstrap-vue";
import { createPinia } from "pinia";
import VueCompositionAPI from "@vue/composition-api";
import browserDetect from "vue-browser-detect-plugin";
import { applyKhmerLocalePatch } from "@/utils/translate";

import i18n from "@/libs/i18n";

// Global Components
import "./global-components";

// 3rd party plugins
import "@/libs/portal-vue";
import "@/libs/clipboard";
import "@/libs/toastification";
import "@/libs/vee-validate";
import "@/libs/acl";

import "@/libs/vue-shortkey";
import "@/libs/sweet-alerts";

import OneSignalVue from "onesignal-vue";

import vueDebounce from "vue-debounce";

import ToggleButton from "vue-js-toggle-button";
// Filter
import "@/filters/dateFilter";
import "@/filters/currencyFilter";

// Custom
import LoadProfile from "@/components/LoadProfile";
import App from "./App.vue";
import store from "./store";
import router from "./router";

import FlagIcon from "vue-flag-icon";

Vue.use(OneSignalVue);
Vue.use(vueDebounce);
Vue.component("load-profile", LoadProfile);

// BSV Plugin Registration
Vue.use(ToastPlugin);
Vue.use(ModalPlugin);
Vue.use(VBTooltipPlugin);
Vue.use(browserDetect);
// VBToggle directive
Vue.directive("b-toggle", VBToggle);

// Composition API
Vue.use(VueCompositionAPI);

Vue.use(createPinia());

Vue.use(ToggleButton);

Vue.use(FlagIcon);

// import core styles
require("@core/scss/core.scss");

// import assets styles
require("@/assets/scss/style.scss");

Vue.config.productionTip = false;

// Apply Khmer Intl.DateTimeFormat patch as early as possible
applyKhmerLocalePatch();

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
